import { defineStore } from "pinia";

type ErrorPageStoreType = {
  // Set from the server-rendered mount element when ErrorsController renders
  // the SPA for a 403/404/422. Drives the initial navigation to the error
  // route in MainEntryPointApp. `undefined` on normal (non-error) page loads.
  status?: string;
};

export const useErrorPageStore = defineStore("errorPage", {
  state: (): ErrorPageStoreType => ({
    status: undefined,
  }),
});
